var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "moodboard" },
    [
      _c("div", { staticClass: "moodboard__upload" }, [
        _c(
          "label",
          {
            staticClass: "button button--primary hint--item upload--xs",
            attrs: { for: "fileElem" },
          },
          [_vm._v(_vm._s(_vm.$t("uploadImage")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "upload__dropzone",
            class: _vm.isHighlighted,
            on: {
              drop: function ($event) {
                $event.preventDefault()
                return _vm.addImage.apply(null, arguments)
              },
              dragover: function ($event) {
                $event.preventDefault()
                return _vm.setHighlight(true)
              },
              dragenter: function ($event) {
                $event.preventDefault()
                return _vm.setHighlight(true)
              },
              dragleave: function ($event) {
                $event.preventDefault()
                return _vm.setHighlight(false)
              },
            },
          },
          [
            !_vm.image
              ? _c("global-responsive-image", {
                  ref: "sampleImage",
                  staticClass: "moodboard__image img-fluid",
                  attrs: { "responsive-image": _vm.sampleImage },
                  on: { load: _vm.analyzeImage },
                })
              : _c("img", {
                  ref: "userImage",
                  staticClass: "moodboard__image img-fluid",
                  attrs: { src: _vm.image },
                  on: { load: _vm.analyzeImage },
                }),
            _vm._v(" "),
            _c("div", { staticClass: "upload__hint" }, [
              _c(
                "div",
                { staticClass: "upload__hint--wrapper" },
                [
                  _c(
                    "transition",
                    {
                      attrs: {
                        name: "transition-moodboard--default",
                        mode: "out-in",
                      },
                    },
                    [
                      !_vm.showProcessing
                        ? _c(
                            "div",
                            {
                              key: "transition-wrapper-1",
                              staticClass: "transition-wrapper",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "hint--item hint--drop" },
                                [
                                  _c("img", {
                                    attrs: {
                                      alt: "drop image here",
                                      src: require("../assets/icon-download.svg"),
                                    },
                                  }),
                                  _vm._v(_vm._s(_vm.$t("dropHere"))),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "hint--item" }, [
                                _vm._v(_vm._s(_vm.$t("or"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  id: "fileElem",
                                  accept: "image/*",
                                },
                                on: { change: _vm.addImage },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "button button--primary hint--item",
                                  attrs: { for: "fileElem" },
                                },
                                [_vm._v(_vm._s(_vm.$t("uploadImage")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showProcessing
                        ? _c(
                            "div",
                            {
                              key: "transition-wrapper-2",
                              staticClass: "transition-wrapper",
                              on: {
                                "after-enter": function ($event) {
                                  _vm.showProcessingContent = true
                                },
                              },
                            },
                            [
                              _vm.analyzing
                                ? _c(
                                    "div",
                                    {
                                      key: "analyzing",
                                      staticClass: "transition-wrapper",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "hint--item" },
                                        [
                                          _c("img", {
                                            staticClass: "animation--spinner",
                                            attrs: {
                                              alt: "loading",
                                              src: require("../assets/icon-spinner.svg"),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "hint--item" },
                                        [_vm._v(_vm._s(_vm.$t("analyzing")))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.requestRunning
                                ? _c(
                                    "div",
                                    {
                                      key: "requestRunning",
                                      staticClass: "transition-wrapper",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "hint--item" },
                                        [
                                          _c("img", {
                                            staticClass: "animation--spinner",
                                            attrs: {
                                              alt: "loading",
                                              src: require("../assets/icon-spinner.svg"),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "hint--item" },
                                        [_vm._v(_vm._s(_vm.$t("matching")))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "dropzone__border dropzone--inner-border",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "dropzone__border dropzone--outer-border",
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("moodboard-result", { attrs: { decors: _vm.result } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "moodboard__devider" }, [
      _c("img", {
        attrs: {
          src: require("../assets/icon-arrow--down.svg"),
          alt: "arrow down",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }